"use client";

import type { ReactNode } from "react";
import { useMemo, useSyncExternalStore } from "react";

import { QueryProvider } from "./QueryProvider";
import { SdkContext, type SdkInstance } from "./sdk-context";

export interface SdkProviderProps {
  sdk: SdkInstance;
  children: ReactNode;
}

export const SdkProvider = ({ sdk, children }: SdkProviderProps) => {
  const configSnapshot = useSyncExternalStore(
    sdk.subscribeToConfigUpdates,
    () => sdk.config,
    () => sdk.config
  );
  const ready = !("isMock" in sdk);

  const value = useMemo(
    () => ({ sdk, config: configSnapshot, ready }),
    [sdk, configSnapshot, ready]
  );

  return (
    <SdkContext.Provider value={value}>
      <QueryProvider>{children}</QueryProvider>
    </SdkContext.Provider>
  );
};
